import { Component, OnInit, Input } from '@angular/core';
import { ReclamacaoService } from 'src/app/service/reclamacao/reclamacao.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';


@Component({
  selector: 'app-cartorio-extrajudicial',
  templateUrl: './cartorio-extrajudicial.component.html',
  styleUrls: ['./cartorio-extrajudicial.component.css']
})
export class CartorioExtrajudicialComponent implements OnInit {

  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  listaClassificacaoComponente = [];
  municipio: any;
  cartorioComponente: any;
  localidade: any[];
  localidadeStr: String = '';
  listaMunicipio: any[];
  listaCartorio: any[];
  cartoriosFiltrados: any[];
  charNum = 5000;
  classificacaoNenhumaOpcaoAnteriorId = 122;

  constructor(
    public service: ReclamacaoService,
    public desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) {
  }

  ngOnInit() {

    this.preencherListaClassificacao();
    // OS 1259
    this.preencherListaMunicipio();

    if (!this.visualizacao && !this.edicao) {

      this.service.reclamacao.controls.descricaoReclamacao.setValue('');
      this.service.reclamacao.controls.municipio.setValue('');
      this.service.reclamacao.controls.cartorio.setValue('');

      this.service.reclamacao.controls.codigoCNS.disable();
      this.limparCampos();

    } else {

      var codigoMunicipio = this.service.reclamacao.controls.codigoMunicipio.value;
      var municiopioSelecionado = this.listaMunicipio.find(mun => mun.codigo == codigoMunicipio);
      //console.log('O valor do codigoMunicipio: ', municiopioSelecionado.nome);
      this.service.reclamacao.controls.municipio.setValue(municiopioSelecionado.nome);

      var codigoComarca = municiopioSelecionado.comrCodigo;
      //console.log('O valor do codigo da comarca: ', codigoComarca);
      this.service.reclamacao.controls.codigoComarca.setValue(codigoComarca);
      this.preencheListaCartoriosPorCodMunicipioCodComarca(codigoMunicipio, codigoComarca);

      //console.log('Valor do objeto buscado =>', this.service.reclamacao.controls);

      if(this.visualizacao){
        this.service.reclamacao.controls.codigoCNS.disable();
        this.service.reclamacao.controls.codigoMunicipio.disable();
        this.service.reclamacao.controls.localidade.disable()
      }


    }
  }
  inicilizaCampos() {
    this.service.reclamacao.controls.localidade.disable();
  }

  preencherListaClassificacao() {

    // Obtendo a classificação Nenhuma das opções anteriores, para ser inserido por ultimo na listagem
    //TODO Deverá se verificado uma forma de transformar a classificação Nenhuma das opções anteriores como
    // o ultimo item de qualquer busca por classificação.
    //Ocorrendo problema ao montar a lista, a mesma é reordenada e perde modificação feita no backend.
    var ultimoItemClassificacao = this.service.reclamacao.value.listaClassificacaoCompleta
        .find(item => item.id === this.classificacaoNenhumaOpcaoAnteriorId);

    this.listaClassificacaoComponente = this.service.reclamacao.value.listaClassificacaoCompleta
      .filter(item =>
          item.assunto.id === this.service.reclamacao.value.assunto.id && item.id !== this.classificacaoNenhumaOpcaoAnteriorId
        );

        this.listaClassificacaoComponente.push(ultimoItemClassificacao);
        //console.log('Lista Cartorio extrajudicial', this.listaClassificacaoComponente);
  }

  preencherListaMunicipio() {
    this.listaMunicipio = this.service.reclamacao.value.listaMunicipio;
    //console.log('Lista de municipios correta ->', this.listaMunicipioCorreta );
    return this.listaMunicipio;
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoesExcetoItem(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  atribuirListaClassificacao() {
    this.service.reclamacao.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.reclamacao.controls[str].touched &&
      this.service.reclamacao.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

  // Fazendo teste com lista de cartórios (OS 1285)
  preencheListaCartoriosPorCodMunicipioCodComarca(codigoMunicipio: number, codigoComarca: number) {
    this.service.buscarCartoriosPorCodMunicipioCodComarca(codigoMunicipio, codigoComarca).subscribe(retorno => {

      if(retorno){
        this.listaCartorio = retorno;
      }
    })
  }

  selecionaMunicipio() {
    var codigoMunicipio = this.service.reclamacao.controls.codigoMunicipio.value;

    if (codigoMunicipio != '') {
      this.service.reclamacao.controls.codigoCNS.enable();
      //console.log('O valor do codigoMunicipio: ', codigoMunicipio);
      var municiopioSelecionado = this.listaMunicipio.find(mun => mun.codigo == codigoMunicipio);
      //console.log('O valor do codigoMunicipio: ', municiopioSelecionado.nome);
      this.service.reclamacao.controls.municipio.setValue(municiopioSelecionado.nome);

      var codigoComarca = municiopioSelecionado.comrCodigo;
      //console.log('O valor do codigo da comarca: ', codigoComarca);
      this.service.reclamacao.controls.codigoComarca.setValue(codigoComarca);

      this.preencheListaCartoriosPorCodMunicipioCodComarca(codigoMunicipio, codigoComarca);

    } else {
      this.limparCampos();
      this.service.reclamacao.controls.codigoCNS.disable();
    }
  }

  selecionaCartorio(){

    // Através da seleção, deverá buscar a devida localidade referente ao cartório
    const codigoCns = this.service.reclamacao.controls.codigoCNS.value;
    //console.log('O valor do codigoCNS', codigoCns);

    if(codigoCns != ''){
      const serventia = this.listaCartorio.find(cl => cl.codigoCNS === codigoCns);
      const nomeServentiaCompleto = serventia.nomeServentia + ' - '+ serventia.nomeMunicipioServentia;
      //console.log('Serventia selecionada =>', serventia);
      this.service.reclamacao.controls.nomeServentia.setValue(nomeServentiaCompleto);
      this.service.reclamacao.controls.localidade.setValue(serventia.localidade);
    }else{
      //console.log('Selecionou Selecione o cartório');
      this.service.reclamacao.controls.localidade.setValue('');
      this.service.reclamacao.controls.nomeServentia.setValue('');
    }
  }


  limparCampos(){
    this.service.reclamacao.controls.codigoMunicipio.setValue('');
    this.service.reclamacao.controls.codigoCNS.setValue('');
    this.service.reclamacao.controls.localidade.setValue('');

    this.listaCartorio = [];
    //this.service.denuncia.controls.listaMunicipio.setValue('');
  }

}
